import { Item } from '@eencloud/eewc-components/src/components/dropdowns/types';
import {
  ApiAccountCapabilities,
  EffectiveAccountPermissions,
  UserPermissions,
} from '@eencloud/eewc-components/src/service/api-types';

export type Route = {
  path: string;
  name: string;
  component: () => void;
  meta: Record<string, any>;
};

export type ErrorMessages = {
  requiredField?: string;
  invalidDate?: string;
  invalidTime?: string;
  dateFormat?: string;
  timeFormat24Hours?: string;
  timeFormat12Hours?: string;
  earlierThanStart?: string;
  laterThanEnd?: string;
};

type SidebarOptionValue = 'today' | 'last24Hours' | 'yesterday' | 'last7Days' | 'last30Days';

export type SidebarOption = {
  text: string;
  option: SidebarOptionValue;
};

export type TranslatedTexts = {
  cancelText: string;
  doneText: string;
  monthNames: string[];
  placeholder?: string;
  sidebarOptions: SidebarOption[];
  weekDayNames: string[];
  startDateTimeLabel?: string;
  endDateTimeLabel?: string;
  errorMessages?: ErrorMessages;
};

export type AdaptiveTimeRange = {
  absolute: [string, string] | null | undefined;
  relative: [number, number] | null | undefined;
};

export type PageInformation = {
  pageToken?: string;
  pageNumber?: number;
  pageSize?: number;
  scrollPosition?: number;
};

export type ScheduleType = '24hours' | 'workHours' | 'nonWorkHours' | 'none';

export type ExtendedScheduleType = ScheduleType | 'custom';

export type Period = {
  day: Item;
  from: Date;
  till: Date;
};

// add types to this as required
export interface AccessContext {
  users: UserPermissions | undefined;
  account: {
    accountCapabilities: ApiAccountCapabilities | undefined;
    effectiveAccountPermissions: EffectiveAccountPermissions | undefined;
  };
  bssUser: boolean;
  demoUser: boolean;
  scimEnabled: boolean;
  videoSearchAlertsEnabled: boolean;
  scimManagedUser: boolean;
}

export enum UserManagementType {
  SCIM = 'scim',
  BSS = 'bss',
  Local = 'local',
}

export interface AnalyticROIPermissions {
  showMotionROI?: boolean;
  showAnalyticROIandLines?: boolean;
}
